<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('acessos-permissoes') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('colaborador') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({ name: 'usuario-acessos-permissoes' })
                                        "
                                        >{{ $t('acessos-permissoes') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        perfil && perfil.idperfilacesso
                                            ? perfil.nome
                                            : $t('perfil')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <div v-if="isLoaded">
                    <ul
                        class="nav nav-tabs nav-tabs-children"
                        v-if="isUpdate"
                        key="agro-visita-manage"
                    >
                        <li
                            v-for="(aba, i) in abas"
                            :key="aba.id"
                            v-show="perm_perfilacessotelas.read"
                            :class="{ active: abaSelecionada == aba.id }"
                            @click="changeTab(aba.id)"
                        >
                            <a data-toggle="tab">
                                <svg
                                    class="svg-icons"
                                    v-if="aba.nome != 'colaborador' && aba.nome != 'geral'"
                                >
                                    <use
                                        :xlink:href="
                                            require(`@/assets/img/contextos/${aba.nome}.svg`) +
                                            '#layer'
                                        "
                                    />
                                </svg>
                                {{ $te(aba.nome) ? $t(aba.nome) : aba.nome }}
                            </a>
                        </li>
                    </ul>

                    <div v-if="!newToEdit">
                        <!-- descrição e situação -->
                        <Geral
                            ref="tabGeral"
                            v-show="abaSelecionada == -1"
                            :isUpdate="isUpdate"
                            :perm_perfilacessotelas="perm_perfilacessotelas"
                            :perfil="perfil"
                        />
                        <!-- Vínculo de usuários -->
                        <Usuarios
                            ref="tabUsuarios"
                            v-if="abasAbertas[0]"
                            v-show="abaSelecionada == 0"
                            :perm_perfilacessotelas="perm_perfilacessotelas"
                            :perfil="perfil"
                        />
                        <!-- Abas de permissão por módulo -->
                        <span
                            v-for="(modulo, i) in app_modulo.data.app_moduloList"
                            :key="modulo.id"
                            class="aba-modulo"
                        >
                            <keep-alive>
                                <Permissoes
                                    :ref="`tab-${modulo.id}`"
                                    v-if="
                                        abasAbertas[modulo.id] &&
                                        perm_perfilacessotelas.read &&
                                        isUpdate
                                    "
                                    v-show="abaSelecionada == modulo.id"
                                    :perm_perfilacessotelas="perm_perfilacessotelas"
                                    :abaSelecionada="modulo"
                                    @isChanged="isChanged = $event"
                                />
                            </keep-alive>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from '@/models/Message';
import Geral from '@/components/colaborador/acesso-permissao/abas/Geral.vue';
import Usuarios from '@/components/colaborador/acesso-permissao/abas/Usuarios.vue';
import Permissoes from '@/components/colaborador/acesso-permissao/abas/Permissoes.vue';
import { mapState } from 'vuex';

export default {
    beforeRouteLeave(to, from, next) {
        if (
            from.name == 'usuario-acessos-permissoes-new' &&
            to.name == 'usuario-acessos-permissoes-edit'
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            next();
            this.carregarDados(to.params.id);
        } else {
            // Caso tenha alguma alteraçõa não salva, pede confirmação
            if (this.isChanged) {
                this.promptChangeTab(next);
            } else {
                next();
            }
        }
    },

    components: {
        Message,
        Usuarios,
        Permissoes,
        Geral,
    },
    data() {
        return {
            perfil: {},

            isSaving: false,
            isLoaded: false,
            saved: false,
            isAdmin: false,

            isChanged: false,
            isUpdate: false,
            newToEdit: false,

            abaSelecionada: -1,
            abas: [
                {
                    id: -1,
                    nome: 'geral',
                },
                {
                    id: 0,
                    nome: 'colaborador',
                },
            ],
            abasAbertas: {},
            perm_perfilacessotelas: {},
        };
    },
    computed: {
        ...mapState(['app_modulo']),
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.perm_perfilacessotelas = this.hasPermissionAccess(
            'admin',
            'colaborador',
            'usuario-acessos-permissoes'
        );
        if (!this.perm_perfilacessotelas.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'acessos-permissoes' },
            });
        } else {
            if (!this.isUpdate && !this.perm_perfilacessotelas.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'acessos-permissoes' },
                });
            } else {
                // caso seja edição carrega os dados, caso contrário abre para cadastro
                if (this.isUpdate) {
                    this.carregarDados(this.$route.params.id);
                } else {
                    this.isLoaded = true;
                    this.abasAbertas[-1] = true;
                }
            }
        }
    },

    methods: {
        changeTab(id) {
            this.abaSelecionada = id;
            this.abasAbertas[id] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => next(false),
            });
        },
        carregarDados(id = 0) {
            this.$store.commit('addLoader');
            this.$axios
                .get(`config/access-profile/${id}.json`)
                .then((response) => {
                    this.isAdmin = response.data.content.admin == 1;
                    this.perfil = response.data.content;
                })
                .finally(() => {
                    if (this.isAdmin) {
                        this.isLoaded = true;
                        this.abasAbertas[-1] = true;
                        this.$store.commit('removeLoader');
                    } else {
                        this.configModules();
                    }
                });
        },
        redirectToPage() {
            setTimeout(() => {
                this.$router.push({ name: 'usuario-acessos-permissoes' });
            }, 1000);
        },
        configModules() {
            this.app_modulo.data.app_moduloList.forEach((moduloPai) => {
                this.abas.push(moduloPai);
            });
            this.newToEdit = false;
            this.isLoaded = true;
            this.abasAbertas[-1] = true;
            this.$store.commit('removeLoader');
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    height: auto;
    min-height: 100%;

    .page {
        position: relative;

        .abas {
            height: 100%;
        }
    }
}
.svg-icons {
    fill: $primary-color;
    background-color: $bg-color;
    width: 15px;
    height: 15px;
}
</style>
